import RecentOrderCP from 'src/components/elements/orderAhead/RecentOrderCP';
import {RecentOrderItemType, RecentOrderType} from 'src/types/RecentOrders';
import Localized from 'src/constants/AppStrings';
import {Text, View, StyleSheet} from 'react-native';
import Styles from 'src/components/Styles';

export function getRecentOrderListItem(
  item: RecentOrderType,
  addItem: (item: RecentOrderItemType) => void,
  addAllItems: (order: RecentOrderType) => void,
  onProductCellPressed: (item: RecentOrderItemType) => void,
) {
  return (
    <RecentOrderCP
      recentOrder={item}
      strings={Localized}
      addItem={addItem}
      addAllItems={addAllItems}
      productCellPressed={onProductCellPressed}
    />
  );
}

export function getEmptyList() {
  return (
    <View style={{justifyContent: 'center', flex: 1}}>
      <Text
        style={styles.emptyText}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
      >
        {Localized.Labels.no_recent_orders}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyText: {
    textAlign: 'center',
    color: Styles.darkColor,
    marginTop: Styles.Spacing.m3,
    fontSize: Styles.Fonts.f7,
    fontWeight: 'bold',
    marginBottom: Styles.Spacing.m3,
  },
});

export default {
  getRecentOrderListItem,
  getEmptyList,
};
